export default "__VITE_ASSET__CVf_vJEX__"